import { gql } from 'graphql-request';

export const siteRiskInsightsAvailableDatesQuery = gql`
    query GetSiteRiskInsightsAvailableDates($organisationBusinessCentralId: String!, $siteId: ID!) {
        site(organisationBusinessCentralId: $organisationBusinessCentralId, siteId: $siteId) {
            riskInsightsAvailableDates
        }
    }
`;

export type SiteRiskInsightsAvailableDatesResult = {
    site: {
        riskInsightsAvailableDates: string[];
    } | null;
};
